module.exports = __webpack_public_path__ + "porch-select-tip.2c150a9b.png";